// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Slider$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/slider/Slider.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";

function getSliderMarks(startTs, endTs, markNumber, totalMarks) {
  var startTs$1 = Timestamp$Catalyst.toFloat(startTs);
  var endTs$1 = Timestamp$Catalyst.toFloat(endTs);
  var value = (endTs$1 - startTs$1) / (totalMarks + 1 | 0) * markNumber + startTs$1;
  return {
          value: Timestamp$Catalyst.milliSecondsToSeconds(value),
          label: Timestamp$Catalyst.toString(Timestamp$Catalyst.make(value), "hh:mm a")
        };
}

function createMarks(totalMarks, _currentMark, _marksLst, startTs, endTs) {
  while(true) {
    var marksLst = _marksLst;
    var currentMark = _currentMark;
    if (currentMark === 0) {
      return marksLst;
    }
    _marksLst = {
      hd: getSliderMarks(startTs, endTs, currentMark, totalMarks),
      tl: marksLst
    };
    _currentMark = currentMark - 1 | 0;
    continue ;
  };
}

function valueLabelComponent(props) {
  return React.createElement(TooltipComponent$Catalyst.make, {
              content: Timestamp$Catalyst.toString(Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(props.value)), "hh:mm a"),
              placement: /* Top */9,
              children: props.children
            });
}

function MapSlider(Props) {
  var aria_labelledbyOpt = Props.aria_labelledby;
  var startTs = Props.startTs;
  var endTs = Props.endTs;
  var totalMarks = Props.totalMarks;
  var classNameOpt = Props.className;
  var value = Props.value;
  var onChange = Props.onChange;
  var aria_labelledby = aria_labelledbyOpt !== undefined ? aria_labelledbyOpt : "";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var marks = createMarks(totalMarks, totalMarks, /* [] */0, startTs, endTs);
  return React.createElement("div", {
              className: "slider-container"
            }, React.createElement(Slider$Catalyst.make, {
                  className: className,
                  aria_labelledby: aria_labelledby,
                  valueLabelComponent: valueLabelComponent,
                  min: Timestamp$Catalyst.milliSecondsToSeconds(Timestamp$Catalyst.toFloat(startTs)),
                  max: Timestamp$Catalyst.milliSecondsToSeconds(Timestamp$Catalyst.toFloat(endTs)),
                  marks: marks,
                  onChange: (function ($$event, ts) {
                      return Curry._2(onChange, $$event, Timestamp$Catalyst.make(Timestamp$Catalyst.secondsToMilliSeconds(ts)));
                    }),
                  value: Timestamp$Catalyst.milliSecondsToSeconds(Timestamp$Catalyst.toFloat(value))
                }));
}

var make = MapSlider;

export {
  getSliderMarks ,
  createMarks ,
  valueLabelComponent ,
  make ,
  
}
/* react Not a pure module */
